<div class="tab-item" *ngIf="active">
  <ng-content></ng-content>
</div>
